import { Components, Theme } from '@mui/material'

export const MuiDrawer: Components<Omit<Theme, 'components'>>['MuiDrawer'] = {
  styleOverrides: {
    paperAnchorRight: {
      width: 'min(480px, 100vw)',
      maxWidth: 600,
    },
  },
}
